import * as XLSX from 'xlsx';

export const parseExcelFile = (arrayBuffer) => {
  const workbook = XLSX.read(arrayBuffer, { type: 'array' });
  const firstSheetName = workbook.SheetNames[0];
  const worksheet = workbook.Sheets[firstSheetName];
  
  const jsonData = XLSX.utils.sheet_to_json(worksheet, { 
    defval: '',
    raw: false
  });

  if (jsonData.length === 0) {
    throw new Error('Arquivo Excel vazio ou não possui dados válidos');
  }

  const allColumns = Object.keys(jsonData[0]);
  const filteredColumns = filterEmptyColumns(jsonData, allColumns);
  
  const columns = filteredColumns.map(key => ({
    accessorKey: key,
    header: key
  }));

  return { data: jsonData, columns };
};

const filterEmptyColumns = (data, columns) => {
  return columns.filter(key => {
    const isEmpty = data.every(row => !row[key] || row[key].toString().trim() === '');
    const isOnlyOk = data.every(row => {
      const value = row[key]?.toString().trim().toLowerCase();
      return !value || value === 'ok';
    });
    return !isEmpty && !isOnlyOk;
  });
};
